import { render, staticRenderFns } from "./addConfigDialog.vue?vue&type=template&id=038682c2&scoped=true"
import script from "./addConfigDialog.vue?vue&type=script&lang=js"
export * from "./addConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./addConfigDialog.vue?vue&type=style&index=0&id=038682c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038682c2",
  null
  
)

export default component.exports